export const referalLang = {
    statistic: {
        'en': 'REFERRAL STATISTIC',
        'fr': 'STATISTIQUE DE PARRAINAGE',
        'de': 'EMPFEHLUNGSSTATISTIK',
        'ko': '추천 통계',
        'ch': '推荐统计',
        'ru': 'РЕФЕРАЛЬНАЯ СТАТИСТИКА',
        'it': 'STATISTICHE DI RIFERIMENTO',
        'jap': '紹介データの統計',
        'port': 'ESTATÍSTICA DE REFERÊNCIA',
        'turk': 'TAVSİYE İSTATİSTİKLERİ',
        'viet': 'THỐNG KÊ GIỚI THIỆU',
        'spa': 'ESTADÍSITICAS DE REFERIDOS',
        'arab': 'إحصائيات الإحالة'
    },
    guest: {
        'en': 'MY GUESTS',
        'fr': 'MES INVITÉS',
        'de': 'MEINE GÄSTE',
        'ko': '내 게스트',
        'ch': '我的访客',
        'ru': 'МОИ ГОСТИ',
        'it': 'I MIEI OSPITI',
        'jap': 'Myゲスト',
        'port': 'MEUS CONVIDADOS',
        'turk': 'KONUKLARIM',
        'viet': 'KHÁCH CỦA TÔI',
        'spa': 'MIS INVITADOS',
        'arab': 'ضيوفي'
    },
}